<template>
  <OmtLayoutHeaderFooter
    class="hub-saude-layout"
    bg="#F6F6F9"
    :header="{ titleLabel: 'Hub de saúde', variant: 'navy', backRoute: headerBackRoute }"
    :footer="true"
  >
    <router-view />
  </OmtLayoutHeaderFooter>
</template>

<script>
export default {
  name: "HubSaude",
  computed: {
    headerBackRoute() {
      return this.$route.meta?.backTo || "/";
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.$root.$emit("change-back-route", route.meta?.backTo || "/");
      }
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style>
.hub-saude-layout .omt-grid:not(.header-grid) {
  background: #f6f6f9;
}

.hub-saude-layout .omt-grid.hub-home {
  width: 100%;
  min-height: calc(100vh - 80px);
  align-content: start;
}

@media screen and (min-width: 1024px) {
  .hub-saude-layout .omt-grid:not(.header-grid) {
    background: #fff;
    border-radius: 16px;
  }

  .hub-saude-layout .omt-grid.hub-home {
    margin-top: 24px !important;
    min-height: calc(100vh - 104px);
  }
}
</style>
